const padNumber = (number) => String(number).padStart(2, "0");

export const getMinutes = (seconds) => padNumber(Math.floor(seconds / 60));

export const getSeconds = (seconds) => padNumber(seconds % 60);
